/**
 * PortalAccounts
 *
 * Handles the setting and getting of a users accounts, as well as the creation of the accounts dropdown
 */

// the constructor for this object
function PortalAccounts() { }

// the object
PortalAccounts.prototype = {
    constructor: PortalAccounts,
    
    // the selector for the accounts dropdown
    dropdownSelector: false,
    
    // if the dropdown should store the selected account id globablly
    dropdownStoreAccountId: true,
    
    // if the dropdown should have the all accounts option
    dropdownAllAccountsOption: true,
    
    // the account id to be used if all accounts is the active id, but the dropdown doesn't support it
    dropdownDefaultAccountId: false,
    
    // make the api call to get the accounts data
    setAccounts: function(successCallback)
    {
        var accountsRequest = new PortalRequest;
        accountsRequest.makeRequest(
            '/accounts/get-accounts',
            {},
            function(data, code, message) {
                PortalMain.PortalAccounts._storeAccountsData(data);
                successCallback(true);
            }, 
            function() {
                successCallback(false);
            }
        );
    },
    
    // save the accounts data to local storage
    _storeAccountsData: function(accountsData)
    {
        var currentAccountId = 0;
        this._storeCurrentAccountId(currentAccountId);
        
        accountsData = JSON.stringify(accountsData);
        localStorage.setItem('portalAccounts', accountsData);
    },
    
    // store the current account id to local storage
    _storeCurrentAccountId: function(currentAccountId)
    {
        localStorage.setItem('portalCurrentAccountId', currentAccountId);
    },
    
    // clear the accounts details from local storage
    clearAccounts: function()
    {
        localStorage.removeItem('portalAccounts');
    },
    
    // get the accounts
    getAccounts: function() 
    {
        if (localStorage.portalAccounts) {
            var accountsData = JSON.parse(localStorage.portalAccounts);
            return accountsData;
        }
        
        return [];
    },
    
    // get only accounts that the user has admin rights on
    getAdminAccounts: function()
    {
        var accounts = this.getAccounts();
        var adminAccounts = [];
        for (var i in accounts) {
            var account = accounts[i];
            if (account.is_account_admin) {
                adminAccounts.push(account);
            }
        }
        
        return adminAccounts;
    },
    
    // get the current account id
    getCurrentAccountId: function() 
    {
        if (localStorage.portalCurrentAccountId) {
            var currentAccountId = localStorage.portalCurrentAccountId;
            return currentAccountId;
        }
        
        return false;
    },
}
